import Alerts from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-alerts-icon.svg';
import Analytics from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-analytics-icon.svg';
import AreaGuides from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-area-guides-icon.svg';
import CMS from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-cms-icon.svg';
import Draw from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-draw-icon.svg';
import Forms from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-forms-icon.svg';
import Images from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-images-icon.svg';
import MobileFriendly from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-mob-friendly-icon.svg';
import News from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-news-icon.svg';
import Search from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-search-icon.svg';
import Security from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-security-icon.svg';
import Testimonials from '@propertypal/shared/src/resources/icons/estate-agent-websites/websites-testimonials-icon.svg';
import Button from '@propertypal/web-ui/src/buttons/Button';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import React from 'react';
import { useTheme } from 'styled-components';
import { TextContent, Container, Wrapper, IconsGrid, IconsGridItem } from './FeaturesSection.style';
import { GradientBgAngle } from './SuperFeature.style';

type Icon = {
  SVG: string;
  heading: string;
  maxW?: number;
};

const icons: Icon[] = [
  {
    SVG: MobileFriendly,
    heading: 'Mobile Friendly',
    maxW: 180,
  },
  {
    SVG: Search,
    heading: 'Extensive Property Search',
    maxW: 220,
  },
  {
    SVG: Draw,
    heading: 'Draw a Search',
    maxW: 170,
  },
  {
    SVG: Alerts,
    heading: 'Property Alerts',
    maxW: 180,
  },
  {
    SVG: Forms,
    heading: 'Customised Online Forms',
    maxW: 220,
  },
  {
    SVG: News,
    heading: 'Latest News & Socials',
    maxW: 170,
  },
  {
    SVG: Testimonials,
    heading: 'Client Testimonials',
    maxW: 220,
  },
  {
    SVG: AreaGuides,
    heading: 'Area Guides & Branch Pages',
    maxW: 170,
  },
  {
    SVG: Images,
    heading: 'Quality Images',
    maxW: 170,
  },
  {
    SVG: CMS,
    heading: 'Comprehensive CMS',
    maxW: 240,
  },
  {
    SVG: Analytics,
    heading: 'Google Analytics',
    maxW: 190,
  },
  {
    SVG: Security,
    heading: 'Website Security',
    maxW: 200,
  },
];

interface FeaturesSectionProps {
  dev?: boolean;
}

const FeaturesSection: React.FC<FeaturesSectionProps> = ({ dev }) => {
  const theme = useTheme();
  return (
    <Container>
      <Wrapper>
        <TextContent>
          <SubHeading fontSize={40} align="center">
            We cater to every {dev ? 'developer' : 'agency'}, customising every detail.
          </SubHeading>
          <Text fontSize={20} align="center">
            Each customer is unique, and so is our approach to website design. However, to stay ahead of your
            competitors and resonate with your audience, we recommend the features below are always considered when it
            comes to your new website.
          </Text>
        </TextContent>
        <IconsGrid>
          {icons.map(({ SVG, heading, maxW }) => (
            <IconsGridItem key={heading} maxW={maxW}>
              <SVG />
              <Text>{heading}</Text>
            </IconsGridItem>
          ))}
        </IconsGrid>
        <Button
          onClick={() => document.getElementById('getInTouch')?.scrollIntoView({ behavior: 'smooth' })}
          maxWidth="330px"
          testID="scroll-to-button"
        >
          Let&apos;s chat
        </Button>
      </Wrapper>
      {!dev && <GradientBgAngle data-testid="bg-angle" color={theme.primary} />}
    </Container>
  );
};

export default FeaturesSection;
